// extracted by mini-css-extract-plugin
export default {"mainContainer":"MainContainer_mainContainer__UZhFb"};